<template>
  <div>
    <van-field name="uploader" label="头像" input-align="right">
      <template #input>
        <van-uploader :after-read="afterRead" v-model="fileList" :max-count="1"/>
      </template>
    </van-field>

    <van-field maxlength="20" v-model="info.name" label="姓名" placeholder="请输入" input-align="right"/>
    <van-field maxlength="20" v-model="info.politicalOutlook" label="政治面貌" placeholder="请输入" input-align="right"/>

    <van-field
            readonly
            clickable
            name="calendar"
            :value="info.birthday"
            label="生日"
            placeholder="请选择"
            @click="birthdayPicker = true"
            input-align="right"
    />
    <van-popup v-model="birthdayPicker" position="bottom">
      <van-datetime-picker
              :value="moment(info.birthday).toDate()"
              type="date"
              @confirm="birthdayConfirm"
              @cancel="birthdayPicker = false"
              :min-date="new Date(1900, 1, 1)"
      />
    </van-popup>

    <van-field name="gender" label="性别" input-align="right">
      <template #input>
        <van-radio-group v-model="info.gender" direction="horizontal">
          <van-radio name="1">男</van-radio>
          <van-radio name="0">女</van-radio>
          <van-radio name="2">未知</van-radio>
        </van-radio-group>
      </template>
    </van-field>

    <van-field maxlength="100" v-model="info.faculty" label="院系" placeholder="请输入" input-align="right"/>
    <!--<van-field-->
    <!--        readonly-->
    <!--        clickable-->
    <!--        name="faculty"-->
    <!--        :value="getDictName(facultyTypeOptions, info.faculty)"-->
    <!--        label="院系"-->
    <!--        placeholder="请选择"-->
    <!--        @click="facultyPicker = true"-->
    <!--        input-align="right"-->
    <!--/>-->
    <!--<van-popup v-model="facultyPicker" position="bottom">-->
    <!--  <van-picker-->
    <!--          value-key="label"-->
    <!--          show-toolbar-->
    <!--          :columns="facultyTypeOptions"-->
    <!--          @confirm="facultyConfirm"-->
    <!--          @cancel="facultyPicker = false"-->
    <!--  />-->
    <!--</van-popup>-->

    <van-field maxlength="4" v-model="info.enrollmentYear" type="number" label="入学年份" placeholder="请输入" input-align="right"/>
    <van-field maxlength="11" v-model="info.mobileNum" label="手机号" placeholder="请输入" input-align="right"/>
    <van-field maxlength="100" v-model="info.email" label="电子邮箱" placeholder="请输入" input-align="right"/>
    <van-field maxlength="100" v-model="info.nation" label="民族" placeholder="请输入" input-align="right"/>
    <van-field maxlength="100" v-model="info.nativePlace" label="籍贯" placeholder="请输入" input-align="right"/>

    <van-field maxlength="200" v-model="info.speciality" autosize type="textarea" label="专业方向" placeholder="请输入"/>
    <van-field maxlength="500" v-model="info.learningExperience" autosize type="textarea" label="学习经历" placeholder="请输入"/>
    <van-field maxlength="500" v-model="info.internshipExperience" autosize type="textarea" label="实习经历" placeholder="请输入"/>
    <van-field maxlength="500" v-model="info.projectExperience" autosize type="textarea" label="项目经历" placeholder="请输入"/>
    <van-field maxlength="500" v-model="info.honorAward" autosize type="textarea" label="荣誉奖励" placeholder="请输入"/>
    <van-field maxlength="200" v-model="info.remark" autosize type="textarea" label="备注" placeholder="请输入"/>

    <!--<van-field name="resumePath" label="简历" input-align="right">-->
    <!--  <template #input>-->
    <!--    <div v-if="info.resumePath">-->
    <!--      <a class="upload-a" :href="filePrefix + info.resumePath" target="_blank">查看</a>-->
    <!--      <a class="upload-a" :href="filePrefix + info.resumePath" download="简历">下载</a>-->
    <!--    </div>-->
    <!--    <div v-else></div>-->
    <!--  </template>-->
    <!--</van-field>-->
    <van-field name="h5ResumePath">
      <template #input>
        <van-uploader :preview-image="false" style="width: 100px" :before-read="beforeReadPdf" :after-read="afterRead2" v-model="h5ResumeList" :max-count="2" accept="*">
          <van-button size="small" icon="plus" type="primary">上传简历</van-button>
        </van-uploader>
        <div v-if="h5ResumeList.length > 0">
          <!--<span>{{ h5ResumeList[0].name || '简历' }}</span>-->
          <!--<span style="color: red">{{ info.auditStatus === '0' ? '待审核' : info.auditStatus === '2' ? '审核未通过' : '' }}</span>-->
          <a class="upload-a" :href="filePrefix + h5ResumeList[0].path" target="_blank">查看</a>
          <a class="upload-a" @click="h5ResumeDelete">删除</a>
        </div>
      </template>
    </van-field>

    <div>
      <div class="van-cell">个人简介</div>
      <quill-editor class="editor" :init-value="info.content" @change="changeEditorContent"></quill-editor>
    </div>

  </div>
</template>

<script>
  import moment from "moment";
  import {getDictName} from '@/utils/common'
  import QuillEditor from '@/components/Editor/QuillEditor'
  import {customUploadFile, FILE_DISPLAY_PREFIX} from "@/api/upload";

  export default {
    name: "studentEdit",
    components: {
      QuillEditor
    },
    props: {
      studentInfo: {
        type: Object,
        default: () => {
        }
      },
      facultyTypeOptions: {
        type: Array,
        default: () => []
      }
    },
    watch: {
      studentInfo(val) {
        if (val.header) {
          this.fileList = [{
            url: this.filePrefix + val.header,
            path: val.header
          }]
        }
        if (val.resumePath) {
          this.h5ResumeList = [{
            url: this.filePrefix + val.resumePath,
            path: val.resumePath
          }]
        }
        // if (val.h5ResumePath && val.auditStatus !== '1') {
        //   this.h5ResumeList = [{
        //     url: this.filePrefix + val.h5ResumePath,
        //     path: val.h5ResumePath
        //   }]
        // }
        this.info = val
      }
    },
    data() {
      return {
        filePrefix: FILE_DISPLAY_PREFIX,
        moment,
        getDictName,
        info: this.studentInfo,
        birthdayPicker: false,
        facultyPicker: false,
        fileList: [],
        h5ResumeList: []
      }
    },
    methods: {
      //文件上传
      afterRead(file) {
        customUploadFile(file).then(res => {
          if (res.code === 10000) {
            this.info.header = res.result[0]
            this.fileList.push({
              url: this.filePrefix + res.result[0],
              path: res.result[0]
            })
          }
        }).catch(e => {
          this.$toast('上传失败' + e)
        }).finally(() => {
          this.fileList = this.fileList.filter(i => i.url)
        })
      },
      beforeReadPdf(file) {
        if (file.type !== 'application/pdf') {
          this.$toast('请上传PDF格式文件！');
          return false;
        }
        return true;
      },
      //文件上传
      afterRead2(file) {
        customUploadFile(file).then(res => {
          if (res.code === 10000) {
            this.info.resumePath = res.result[0]
            // this.info.h5ResumePath = res.result[0]
            this.info.auditStatus = '1'
            this.h5ResumeList = [{
              url: this.filePrefix + res.result[0],
              path: res.result[0]
            }]
          }
        }).catch(e => {
          this.$toast('上传失败' + e)
        }).finally(() => {
          this.h5ResumeList = this.h5ResumeList.filter(i => i.url)
        })
      },
      h5ResumeDelete () {
        this.h5ResumeList = []
        delete this.info.resumePath
        // delete this.info.h5ResumePath
        delete this.info.auditStatus
      },
      changeEditorContent (editorContent) {
        this.info.content = editorContent
      },
      birthdayConfirm(e) {
        this.info.birthday = moment(e).format('YYYY-MM-DD')
        this.birthdayPicker = false
        this.$forceUpdate()
      },
      facultyConfirm(e) {
        this.info.faculty = e.value
        this.facultyPicker = false
        this.$forceUpdate()
      },
      getInfo() {
        return this.info
      }
    }
  }
</script>

<style scoped>
  /deep/ .van-uploader {
    display: flex;
    width: 40px;
    height: 40px;

  }

  /deep/ .van-uploader__preview-image {
    width: 40px;
    height: 40px;
    border-radius: 100px;
    overflow: hidden;
  }

  /deep/ .van-uploader__preview {
    margin: 0;
  }

  /deep/ .van-uploader__upload {
    width: 40px;
    height: 40px;
    border-radius: 100px;
  }

  /deep/ .van-uploader__file {
    width: auto;
    height: auto;
  }

  .editor{
    background-color: #ffffff;
    padding: 0 10px 10px 10px;
  }

  .upload-a {
    color: #2C68E4;
    margin-left: 15px
  }
</style>
